module.exports = __webpack_public_path__ + "img/7.7d2b8694.png";